import GiftCard from './GiftCard';
export default GiftCard;